import React from 'react';
import barrelFetaImage from '../../../../src/assets/images/barrel-feta.jpg'; // Adjust the path to your image file
import './Feta.styled.css';
import { FaCheese, FaPepperHot, FaUtensilSpoon, FaNutritionix, FaApple } from 'react-icons/fa'; // Importing some icons from react-icons


const FetaSection = () => {
  return (
    <section className="flex flex-col items-center md:flex-row w-full feta-section py-12" id="feta-section">
      {/* Left Side - Image */}
      <div className="w-full md:w-1/2 h-full flex justify-center items-center ml-0 md:ml-8 mb-4 md:mb-0">
        <img
          src={barrelFetaImage}
          alt="Feta Cheese"
          className="feta-section-img object-cover h-full w-full"
        />
      </div>


      {/* Right Side - Content */}
      <div className="w-full md:w-1/2 flex flex-col justify-center px-6 md:p-12 gap-3 md:py-3 h-full">
        {/* Title */}
        <h1 className="text-3xl md:text-5xl font-bold text-[#DC143C] mb-4">
          Barrel Feta
        </h1>

        {/* Description */}
        <p className="text-m md:text-xl text-gray-700 mb-6">
          Crafted exclusively from a precise blend of sheep's and goat's milk, Feta is a soft, crumbly cheese with a tangy, mildly salty flavor that intensifies as it matures.
        </p>

        {/* Icon and Paragraph Section */}
        <div className="flex flex-col space-y-4">
          <div className="flex flex-col items-center">
            <p className="text-m md:text-xl text-gray-700">
              Protected by the European Union's PDO (Protected Designation of Origin), only cheeses produced in specific regions of Greece using traditional methods can bear the name 'Feta.' Stored in brine, this traditional process ensures its unparalleled freshness and enhances its distinctive taste.
            </p>
          </div>

        </div>

        {/* Flavor Profile (Circular Buttons and Ratings) */}
        <div className="flex flex-wrap justify-center space-x-4 mt-8">
          <div className="flex flex-col items-center">
            <FaPepperHot className="text-green-600 text-2xl mb-2" />
            <span className="text-gray-900 font-bold text-lg">Savory</span>
            <span className="text-blue-600 text-xl">●●●●○○</span>
          </div>
          <div className="flex flex-col items-center">
            <FaCheese className="text-yellow-600 text-2xl mb-2" />
            <span className="text-gray-900 font-bold text-lg">Custard</span>
            <span className="text-blue-600 text-xl">●●●○○○</span>
          </div>
          <div className="flex flex-col items-center">
            <FaUtensilSpoon className="text-red-600 text-2xl mb-2" />
            <span className="text-gray-900 font-bold text-lg">Tangy</span>
            <span className="text-blue-600 text-xl">●●○○○○</span>
          </div>
          <div className="flex flex-col items-center">
            <FaNutritionix className="text-green-600 text-2xl mb-2" />
            <span className="text-gray-900 font-bold text-lg">Nutty</span>
            <span className="text-blue-600 text-xl">●●●●○○</span>
          </div>
          <div className="flex flex-col items-center">
            <FaApple className="text-blue-600 text-2xl mb-2" />
            <span className="text-gray-900 font-bold text-lg">Fruity</span>
            <span className="text-blue-600 text-xl">●●●○○○</span>
          </div>
        </div>
      </div>
    </section>

  );
};

export default FetaSection;
